/**
 * Created by dx.yang on 16/5/9.
 */


import _ from 'lodash';
import suid from './suid';
import uuid from './uuid';
// var uuid = require('./uuid');

var defaultConfig = {
    // 超时
    // timeout: false,
    // 状态描述字段
    // codeField: 'status',
    // 成功
    successCode: 0,
    // 内容字段
    dataField: 'data',
    // 错误描述字段
    errorField: 'error'
};

var loadingMaskClassName = '.ksc-loading-mask';
var loadingMaskHTML = '<div class="' + loadingMaskClassName.replace('.', '') + '"></div>'

var allRequests = {};

var KsRequestClass = function(config) {
    config = config || {};

    var me = this;
    me.config = _.assign({}, defaultConfig, config);

    me.all = function(jqueryDefers) {
        return new Promise(function(resolve, reject) {
            var list = [];
            var count = 0;
            _.forEach(jqueryDefers, (v, i) => {
                v.done((d) => {
                    list[i] = {
                        success: true,
                        data: d
                    };
                }).fail((c, e) => {
                    list[i] = {
                        success: false,
                        code: c,
                        error: e
                    }
                }).always(() => {
                    count += 1;
                    if (count === jqueryDefers.length) {
                        resolve(list);
                    }
                });
            });
        });
    };

    me.request = function(ajaxOptions) {
        var uid = suid('KsAjax');
        var cfg = me.config;

        var defer = $.Deferred();

        //$('.ksc-loading-mask')
        // console.log(ajaxOptions.showLoading);
        if ($(loadingMaskClassName).length === 0 && ajaxOptions.showLoading) {
            $('body').append(loadingMaskHTML);
        }

        var ajax = $.ajax(ajaxOptions).done(function(json) {

            if (!cfg.codeField) {
                defer.resolve(json);
                return;
            }

            if (json[cfg.codeField] === cfg.successCode) {
                defer.resolve(json[cfg.dataField]);
            } else {
                defer.reject(json[cfg.codeField], json[cfg.errorField]);
            }
        }).fail(function(xhr, textStatus) {
            if (xhr.status === 0 || xhr.readyState == 0 || xhr.statusText === 'abort') {
                return;
            }
            if (xhr.status == 200) {
                defer.reject(xhr.status, 'JSON Error');
            } else {
                var json = xhr.responseText;
                try {
                    json = JSON.parse(json);
                    if (typeof json === 'string') {
                        json = JSON.parse(json);
                        // } else {
                        //     json = json.Error;
                    }
                } catch(e) {
                    json = e;
                }
                defer.reject(xhr.status, json);
            }
        }).always(function() {
            delete allRequests[uid];

            var noRequestNeedLoading = _.every(allRequests, ['showLoading', false]);

            if (noRequestNeedLoading) {
                $(loadingMaskClassName).fadeOut(() => {
                    $(loadingMaskClassName).remove();
                });
            }

        });
        var rt = defer.promise();
        rt.abort = function() {
            ajax.abort();
        };
        rt.ajax = ajax;
        allRequests[uid] = rt;
        return rt;
    };

    me.clearAll = function() {
        _.forEach(allRequests, function(v, k) {
            v.abort();
        });
    };

    var methods = ['GET', 'POST', 'PUT', 'DELETE', 'HEAD', 'PATCH', 'JSONP', 'JSON'];
    _.forEach(methods, function(m) {
        me[m.toLowerCase()] = function (url, data, options) {
            options = options || {};
            options.method = m;
            options.url = url;
            if (typeof options.showLoading !== 'boolean') {
                options.showLoading = true;
            }
            //TraceId
            var theUUID = uuid.create().toString();
            var TraceId = theUUID//(new Date() * 1) + '_' + theUUID + '_' + ~~(Math.random() * 10000);
            // options.showLoading = true;
            if (m === 'POST' || m === 'PUT') {
                if ($.isArray(data)) {
                    // url 参数
                    var params = data[0];
                    // 非url参数
                    data = data[1];
                    params.TraceId = TraceId;
                    if (url.indexOf('?') === -1) {
                        options.url += '?' + $.param(params);
                    } else if (params) {
                        options.url += '&' + $.param(params);
                    }
                } else {
                    var params = {
                        TraceId
                    };
                    if (url.indexOf('?') === -1) {
                        options.url += '?' + $.param(params);
                    } else if (params) {
                        options.url += '&' + $.param(params);
                    }
                }
                if (options.isJSON) {
                    options.contentType = "application/json; charset=utf-8";
                    data = JSON.stringify(data);
                }
            }


            if (m === 'GET') {
                data = _.pickBy(data, (v) => {
                    return v !== null && v !== undefined && v !== '';
                });
                data.TraceId = TraceId;
            }

            // disabled browser cache
            // if (typeof options.cache === 'undefined') {
            //     options.cache = false;
            // }

            options.data = data;



            // options.data.TraceId = TraceId;
            return me.request(options);
        };
    });
};


/**
 * 根据指定字段, 判断请求是否成功, 并从指定字段获取成功/失败数据
 */
var ajax = new KsRequestClass({
    // 状态描述字段
    codeField: 'status',
    // 成功
    successCode: 0,
    // 内容字段
    dataField: 'data',
    // 错误描述字段
    errorField: 'error'
});
export {
    ajax,
    KsRequestClass
}

// module.export = new KsRequestClass();

/**
 * 默认输出的实例, 通过http状态判断成功失败, 并将完整返回数据传递给后面的handler
 */
export default new KsRequestClass();

